export var dataHooks = {
  tickerUp: 'ticker-up-button',
  tickerDown: 'ticker-down-button'
};